import { Layout } from "@/components/layout/Layout";
import { AssessmentFlow } from "@/components/inventory/AssessmentFlow";

const StartInventory = () => {
  return (
    <Layout>
      <section className="section-padding bg-background min-h-[80vh]">
        <div className="container-wide">
          <AssessmentFlow />
        </div>
      </section>
    </Layout>
  );
};

export default StartInventory;
